import CSS from "csstype";

export var propertyPanel: CSS.Properties = {
	width: "99%",
	height: "100%",
};
